import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import { bootstrap } from 'vue-gtag'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    assetsBaseUrl: 'https://assets.urlaubimwaldviertel.at/',
    standort: '',
    error: false,
    isiOS: false,
    showInstallDialog: false,
    contentLoaded: false,
    errorMsg: '',
    cookie: false,
    cookies_maps: false,
    cookies_facebook: false,
    cookies_yt: false,
    cookies_ga: false,
    loading: false,
    isLogged: false,
    location: false,
    showLocTooltip: true,
    zoom: 10,
    myPos: { lat: 48.7913791, lng: 15.660817899999984 },
    center: { lat: 48.7913791, lng: 15.660817899999984 },
    content: [],
    filterContent: false,
    filterContentBy: [],
    infoOptions: {
      pixelOffset: {
        width: 0,
        height: -20
      }
    },
    allTags: [1, 2, 16, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17],
    icon1: { // Allgemein
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: '#8e8e8e',
      fillOpacity: 0.7,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 0.7
    },
    icon2: { // Veranstaltung
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: '#000080',
      fillOpacity: 0.7,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 0.7
    },
    icon3: { // Ausflugsziel
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: '#209cee',
      fillOpacity: 0.7,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 0.7
    },
    icon4: { // Kulinarium
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: '#e6194b',
      fillOpacity: 0.7,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 0.7
    },
    icon5: { // Unterkunft
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: '#ffdd57',
      fillOpacity: 0.7,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 0.7
    },
    bluedot: {
      path: 'm0,7.5c0,-4.41989 3.580111,-8 8,-8c4.41989,0 8,3.580111 8,8c0,4.41989 -3.580111,8 -8,8c-4.41989,0 -8,-3.580111 -8,-8z',
      fillColor: '#3a86f5',
      fillOpacity: 1,
      strokeColor: '#ffffff',
      strokeWeight: 3,
      scale: 1
    }
  },
  mutations: {
    clearError (state) {
      state.error = false
      state.errorMsg = ''
    },
    allowLocation (state, payload) {
      state.location = payload
    },
    setPos (state, payload) {
      state.myPos = payload
    },
    setCenter (state, payload) {
      state.center = payload
    },
    setZoom (state, payload) {
      state.zoom = payload
    },
    setErrorMsg (state, payload) {
      state.error = true
      state.errorMsg = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    LOGIN_USER (state) {
      state.isLogged = true
    },
    acceptCookies (state) {
      state.cookie = true
    },
    editCookies (state) {
      state.cookie = false
    },
    setCookies (state, payload) {
      state.cookies_maps = payload.maps
      state.cookies_yt = payload.videos
      state.cookies_ga = payload.ga
      state.cookie = true
      if (payload.ga) {
        bootstrap().then((gtag) => {
          console.log('GA aktiviert')
          Vue.$gtag.optIn()
        })
      } else {
        Vue.$gtag.optOut()
      }
    },
    autoActivateGA (state) {
      if (state.cookies_ga) {
        bootstrap().then((gtag) => {
          console.log('GA aktiviert')
        })
      }
    },
    toggleLocTooltip (state) {
      state.showLocTooltip = !state.showLocTooltip
    },
    LOGOUT_USER (state) {
      axios
        .post('/auth/logout')
        .then(function(response) {
          console.log(response)
          state.isLogged = false
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    sortContent (state) {
      state.content.sort((a, b) => this.getters.calcDistance(a.address.position) - this.getters.calcDistance(b.address.position))
    },
    filterContent (state) {
      state.filterContent = !state.filterContent
    },
    isiOS (state) {
      state.isiOS = true
    },
    showInstallDialog (state, payload) {
      state.showInstallDialog = payload
    },
    filterContentBy (state, payload) {
      state.filterContent = true
      var i = state.filterContentBy.indexOf(payload)
      if (i === -1) {
        state.filterContentBy.push(payload)
      } else {
        state.filterContentBy.splice(i, 1)
      }
    },
    setFilterBy (state, payload) {
      state.filterContentBy = payload
      state.filterContent = true
    },
    setStandort (state, payload) {
      state.standort = payload
    },
    fetchContentFrontend (state, payload) {
      state.content = payload
      state.contentLoaded = true
    }
  },
  actions: {
    // check if CMS has a valid token saved in local storage
    // tryAutoLogin ({ commit }) {
    //   const token = localStorage.getItem('token')
    //   if (!token) {
    //     return
    //   }
    //   const expirationDate = new Date(localStorage.getItem('expirationDate'))
    //   const now = new Date()
    //   if (now >= expirationDate) {
    //     localStorage.removeItem('token')
    //     localStorage.removeItem('expirationDate')
    //     localStorage.removeItem('rtoken')
    //     localStorage.removeItem('rid')
    //     return
    //   }
    //   commit('LOGIN_USER')
    // },
    toggleLocTooltip ({ commit }) {
      commit('toggleLocTooltip')
    },
    // show modal if its users first time visit
    // firstTimeVisit ({commit}) {
    //   const wasHere = localStorage.getItem('allowLocation')
    //   if (!wasHere) {
    //     commit('welcomeModal', true)
    //   } else {
    //     commit('allowLocation', true)
    //   }
    // },
    // user allows gelocation, locate
    getLocation ({ commit }) {
      commit('setLoading', true)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const Pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          // localStorage.setItem('allowLocation', true)
          commit('setPos', Pos)
          commit('setCenter', Pos)
          commit('sortContent')
          commit('setStandort', 'Aktueller Standort')
          commit('allowLocation', true)
          commit('setLoading', false)
        }, () => {
          alert('Fehler: Lokalisierung nicht möglich')
          commit('setLoading', false)
        })
      } else {
        alert('Fehler: Lokalisierung nicht möglich')
        commit('setLoading', false)
      }
    },
    fetchContentFrontend ({ commit }) {
      axios.get('/content/frontend')
        .then(function (res) {
          commit('fetchContentFrontend', res.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    filterContent ({ commit, state }) {
      // reset filter selection if previously set
      if (state.filterContent === true) {
        commit('setFilterBy', [])
      }
      commit('filterContent')
    },
    isiOS ({ commit }) {
      commit('isiOS')
    },
    showInstallDialog ({ commit }) {
      commit('showInstallDialog')
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    cookies_facebook (state) {
      return state.cookies_facebook
    },
    cookies_maps (state) {
      return state.cookies_maps
    },
    cookies_ga (state) {
      return state.cookies_ga
    },
    cookies_yt (state) {
      return state.cookies_yt
    },
    assetsBaseUrl (state) {
      return state.assetsBaseUrl
    },
    error (state) {
      return state.error
    },
    errorMsg (state) {
      return state.errorMsg
    },
    cookie (state) {
      return state.cookie
    },
    isAuthenticated (state) {
      return state.isLogged
    },
    location (state) {
      return state.location
    },
    showLocTooltip (state) {
      return state.showLocTooltip
    },
    zoom (state) {
      return state.zoom
    },
    myPos (state) {
      return state.myPos
    },
    center (state) {
      return state.center
    },
    content (state) {
      return state.content
    },
    contentLoaded (state) {
      return state.contentLoaded
    },
    filterContent (state) {
      return state.filterContent
    },
    filterContentBy (state) {
      return state.filterContentBy
    },
    infoOptions (state) {
      return state.infoOptions
    },
    allTags (state) {
      return state.allTags
    },
    icon1 (state) {
      return state.icon1
    },
    icon2 (state) {
      return state.icon2
    },
    icon3 (state) {
      return state.icon3
    },
    icon4 (state) {
      return state.icon4
    },
    icon5 (state) {
      return state.icon5
    },
    bluedot (state) {
      return state.bluedot
    },
    standort (state) {
      return state.standort
    },
    isiOS (state) {
      return state.isiOS
    },
    showInstallDialog (state) {
      return state.showInstallDialog
    },
    getArticle (state, getters) {
      return (niceUrl) => {
        return getters.content.find(content => {
          return content.seo.niceUrl === niceUrl
        })
      }
    },
    toRad (state) {
      return (val) => {
        return val * Math.PI / 180
      }
    },
    calcDistance (state, getters) {
      return (to) => {
        const R = 6371 // earth radius
        const toLat = getters.toRad(to.lat)
        const myPosLat = getters.toRad(state.myPos.lat)
        const x = (getters.toRad(to.lng) - getters.toRad(state.myPos.lng)) * Math.cos((myPosLat + toLat) / 2)
        const y = (toLat - myPosLat)
        return Math.round((Math.sqrt(x * x + y * y) * R) * 10) / 10
      }
    }
  },
  plugins: [createPersistedState({
    paths: ['standort', 'location', 'myPos', 'filterContent', 'filterContentBy', 'content', 'center', 'contentLoaded', 'cookie', 'showInstallDialog', 'cookies_ga', 'cookies_maps', 'cookies_yt']
  })]
})
